import { render, staticRenderFns } from "./ConstructionRegister.vue?vue&type=template&id=65a9e3f6&"
import script from "./ConstructionRegister.vue?vue&type=script&lang=ts&"
export * from "./ConstructionRegister.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
